export const ASISTENCIA_DOCUMENTOS_MAX = 3;
export const ASISTENCIA_DOCUMENTO_MAX_BYTES = 3 * 1024 * 1024;
const acceptedTypes = new Set(['application/pdf', 'image/jpeg', 'image/png', 'image/webp']);

export function validarDocumentoAsistencia(file) {
    if (!file || file.size > ASISTENCIA_DOCUMENTO_MAX_BYTES || !acceptedTypes.has(file.type)) {
        throw new Error('Adjuntá PDF o imágenes JPG, PNG o WebP de hasta 3 MB. Si escaneaste, probá con menos páginas.');
    }
}

export function agregarDocumentosAsistencia(current, incoming) {
    const added = Array.from(incoming || []);
    if (current.length + added.length > ASISTENCIA_DOCUMENTOS_MAX) throw new Error('Podés adjuntar hasta 3 documentos. Quitá un archivo antes de agregar otro.');
    added.forEach(validarDocumentoAsistencia);
    return [...current, ...added];
}
